import apiClient from './client';

export const usersApi = {
  // Get all users
  list: async (params = {}) => {
    try {
      const response = await apiClient.get('/users', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error);
      throw error;
    }
  },

  // Get single user by ID
  get: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user:', error);
      throw error;
    }
  },

  // Create new user
  create: async (userData) => {
    try {
      const response = await apiClient.post('/users', userData);
      return response.data;
    } catch (error) {
      console.error('Error creating user:', error);
      throw error;
    }
  },

  // Update user
  update: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error updating user:', error);
      throw error;
    }
  },

  // Delete user
  delete: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
  },

  // Update user permissions
  updatePermissions: async (userId, permissions) => {
    try {
      const response = await apiClient.put(`/users/${userId}/permissions`, { permissions });
      return response.data;
    } catch (error) {
      console.error('Error updating user permissions:', error);
      throw error;
    }
  },

  // Update user schedule
  updateSchedule: async (userId, schedule) => {
    try {
      const response = await apiClient.put(`/users/${userId}/schedule`, { schedule });
      return response.data;
    } catch (error) {
      console.error('Error updating user schedule:', error);
      throw error;
    }
  },

  // Update user status (activate/deactivate)
  updateStatus: async (userId, status) => {
    try {
      const response = await apiClient.put(`/users/${userId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Error updating user status:', error);
      throw error;
    }
  },

  // Bulk update users
  bulkUpdate: async (userIds, updates) => {
    try {
      const response = await apiClient.post('/users/bulk-update', { userIds, updates });
      return response.data;
    } catch (error) {
      console.error('Error bulk updating users:', error);
      throw error;
    }
  },

  // Get user activity
  getActivity: async (userId, params = {}) => {
    try {
      const response = await apiClient.get(`/users/${userId}/activity`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching user activity:', error);
      throw error;
    }
  },

  // Get user permissions matrix
  getPermissionsMatrix: async () => {
    try {
      const response = await apiClient.get('/users/permissions-matrix');
      return response.data;
    } catch (error) {
      console.error('Error fetching permissions matrix:', error);
      throw error;
    }
  },

  // Get user roles
  getRoles: async () => {
    try {
      const response = await apiClient.get('/users/roles');
      return response.data;
    } catch (error) {
      console.error('Error fetching roles:', error);
      throw error;
    }
  }
};

export default usersApi;